import React, { useEffect, useState } from "react";
import { useStorageContext } from "./../../Context/StorageContext";
import UploadHandler from "./UploadHandler";
import GalleryImage from "./GalleryImage";
export default function GalleryModal({
  openGallery,
  openGalleryF,
  uploadedShop,
  alreadyExists,
  uploadedZip,
  uploadingZip,
  handleChange,
  handleUploadShopImage,
  chosingCover,
  choseCoverF,
  insertImageMode,
  insertImageF,
  galleryForLink,
  handleInsert,
  magazine,
  chooseMagazine
  
}) {
  const [addNew, setAddNew] = useState(false);
  const [newUpload, setNewUpload] = useState(false);
  const [search, setSearch] = useState("");
  const [phQuantity, setPhQuantity] = useState(1);
  const [url, setUrl] = useState(null);
  const { allImagesLinks, render } = useStorageContext();




  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [getItemsForCurrentPage, setGetItemsForCurrentPage] = useState([]);

  const addNewF = () => {
    setCurrentPage(1)
    setAddNew(!addNew);
  };
  // Función para obtener el array de productos a mostrar en la página actual

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setGetItemsForCurrentPage(
      allImagesLinks
        .filter((e) => e.toUpperCase().includes(search.toUpperCase()))
        .slice(startIndex, endIndex)
    );
  }, [allImagesLinks, search, currentPage, newUpload]);

  // Función para ir a la página anterior
  const goToPreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    window.scrollTo(0, 0);
  };

  // Función para ir a la página siguiente
  const goToNextPage = () => {
    const maxPage = Math.ceil(allImagesLinks.length / itemsPerPage);
    setCurrentPage((prevPage) => Math.min(prevPage + 1, maxPage));
    window.scrollTo(0, 0);
  };

  const handleSelectShopImage = (a) => {
    setUrl(`${a}`);
    openGalleryF();

    setTimeout(() => {
      setPhQuantity(phQuantity + 1);
    }, 200);
  };



  return (
    <div className="admin-images-gallery">
      <div className="admin-images-gallery-row-column">
        <div
          className={`admin-images-gallery-choser ${
            addNew ? "choser-100" : newUpload ? "choser-none" : ""
          } `}
          onClick={ !addNew ? () => {
            addNewF()
          } : null}
        >
          {!addNew ? (
            <>
              <img
                width="50"
                height="50"
                src="https://img.icons8.com/ios/50/add--v1.png"
                alt="add--v1"
              />
              <p> Subir nueva foto</p>
            </>
          ) : (
            <>
             <button className="buttonstyle"  onClick={addNewF} ><img width="30" height="30" src="https://img.icons8.com/fluency-systems-filled/96/circled-left-2--v2.png" alt="circled-left-2--v2"/></button>

             <UploadHandler handleSelectShopImage={handleSelectShopImage} />

            </>
          )}
        </div>

        <div
          className={`admin-images-gallery-choser ${
            newUpload ? "choser-100" : addNew ? "choser-none" : ""
          } `}
          onClick={ !newUpload ? () => {
            setNewUpload(!newUpload);
          } : null }
        >

{!newUpload ? (
            <>
          <img
            width="50"
            height="50"
            src="https://img.icons8.com/wired/64/gallery.png"
            alt="gallery"
          />
          <p>Elegir de la galería</p>
            </>
          ) : (
            <>
             <button className="buttonstyle"  onClick={() => {
            setNewUpload(!newUpload);
          }} ><img width="30" height="30" src="https://img.icons8.com/fluency-systems-filled/96/circled-left-2--v2.png" alt="circled-left-2--v2"/></button>

             <div className="rowOfImagesEdit">
            {getItemsForCurrentPage.map((e) => (
              <GalleryImage
                key={e}
                url={e}
                handleSelectShopImage={handleSelectShopImage}
                chosingCover={chosingCover}
                choseCoverF={choseCoverF}
                insertImageMode={insertImageMode}
                insertImageF={insertImageF}
                galleryForLink={galleryForLink}
                handleInsert={handleInsert}
                magazine={magazine}
                chooseMagazine={chooseMagazine}
              />
            ))}
          </div>
          <div className="searcherRow">
            <img
              className="lupaImg"
              width="25"
              height="25"
              src="https://img.icons8.com/ios/100/search--v1.png"
              alt="search--v1"
            />
            <input
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Buscá por nombre de archivo"
              className="input w20rem"
            ></input>
          </div>
          <div className="changerPageButtonCont">
            <button
              className="buttonbyn"
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
            >
              Anterior
            </button>

            <button className="buttonbyn" onClick={goToNextPage}>
              Siguiente
            </button>
          </div>

            </>
          )}


        </div>
      </div>

     

      {/* <div className='column'>
                    <p className='tittle'>FOTO EN ALTA</p>
                    <div className={uploadingImageHD === true ? 'dropArea uploading' : dragenter === true ? "dropArea dragEnter" : 'dropArea'}
                      onDrop={handleDropSingle}
                      onDragEnter={drag}
                      onDragLeave={dragleave}
                      onDragOver={(e) => e.preventDefault()}>

                      {image && (<p> {image.name} </p>)}

                      <p className='dragText'> {image !== null ? <></> : "Arrastrá y soltá la foto en ALTA"} </p>

                      {uploadedImageHD === true ?
                        <img className="uploadImg uploadAnim" src="https://img.icons8.com/external-kiranshastry-solid-kiranshastry/64/FFFFFF/external-check-multimedia-kiranshastry-solid-kiranshastry.png" /> :

                        <img className={image !== null ? "uploadImg" : "uploadImgF"} src="https://img.icons8.com/ios-filled/100/FFFFFF/send-letter--v1.png" />}

                    </div>
                    <button className='uploadButton' onClick={handleUploadDownloadImage}>
                      {uploadingImageHD === true ?

                        <>
                          Cargando
                          <div className='loadingAbs'>
                            <RaceBy
                              width="90%"
                              size={40}
                              lineWeight={5}
                              speed={1.4}
                              color="#cb5a5a"
                              margin="0"

                            />
                          </div>
                        </>

                        : "Subir archivo"}

                    </button>
                  </div> */}

      <button className="buttonbyn" onClick={openGalleryF}>
        Cerrar
      </button>
    </div>
  );
}
